<!-- 底部组件 -->
<template>
  <div>
    <div class="list" @click="goDetail()">
      <div class="image-container"><img :src="$store.state.imgUrl+msg.coverImg"></div>
      <div class="title oneLine">{{msg.title}}</div>
      <div class="text oneLine">{{msg.subTitle}}</div>
      <div class="time">{{msg.publishTime}}</div>
      <div class="btn">查看详情 ></div>
      <img class="border" src="../assets/pc/border.png" alt="">
    </div>
  </div>
</template>
    
<script>
  export default {
    name: 'active',
    inject: ['reload'],
    props: ["msg", "type"],
    data() {
      return {
        
      };
    },
    methods: {
      goDetail: function() {
        if(this.type == 2){
          this.$router.push({path: "ownerDetail?id="+this.msg.id});
        }else{
          this.$router.push({path: "activeDetail?id="+this.msg.id});
        }
      }
    },
    mounted() {
    }
  };
</script>

<style scoped lang='scss'>
  .list{
    width: 404px;
    height: 457px;
    background: #FFFFFF;
    padding: 24px 22px;
    box-shadow: 0px 0px 20px 0px rgba(106,92,245,0.15);
    position: relative;
    cursor: pointer;

    .image-container{
      width: 359px;
      height: 240px;
      margin-bottom: 28px;
    }

    .title{
      font-weight: 600;
      font-size: 20px;
      color: #252525;
      margin-bottom: 12px;
    }

    .text{
      font-size: 12px;
      color: #666666;
      margin-bottom: 12px;
    }

    .time{
      font-size: 12px;
      color: #666666;
      margin-bottom: 30px;
    }

    .btn{
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      color: #9B9B9B;
    }

    .border{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      display: none;
    }

    &:hover{
      .border{
        display: block;
      }
    }
  }

  @media screen and ( max-width: 750px ) {
    .list{
      width: 4.04rem;
      height: 4.87rem;
      padding: 0.24rem 0.22rem;
      box-shadow: 0px 0px 0.2rem 0 rgba(106,92,245,0.15);
      margin-right: 0.2rem;

      .image-container{
        width: 3.59rem;
        height: 2.40rem;
        margin-bottom: 0.25rem;
      }

      .title{
        font-size: 0.28rem;
        margin-bottom: 0.12rem;
      }

      .text{
        font-size: 0.22rem;
        margin-bottom: 0.1rem;
      }

      .time{
        font-size: 0.18rem;
        margin-bottom: 0.20rem;
      }

      .btn{
        font-size: 0.18rem;
      }

      .border{
        height: 0.04rem;
      }

      &:hover{
        .border{
          display: block;
        }
      }
    }
  }
</style>
    


// WEBPACK FOOTER //
// src/components/activeOne.vue